export default __webpack_public_path__ + "static/media/Air Pollution 63d753e2ace345cc8d3f852f7796333d.bd2ef418.md";